<template>
  	<div class="stores">
    	<div class="breadcrumb">类型管理 > 类型列表</div>
		<div class="hall-search-list">
			<el-button size='small' type="primary" @click="add" plain v-has="'course_type_add'">新建</el-button>
			<span class="hall-search-name">运动类型:</span>
			<el-select v-model="selectSportsId" placeholder="请选择" @change="selectChage">
				<el-option label="全部" value="0">
			</el-option>
			<el-option
				v-for="item in sportsKindList" 
				:key="item.id"
				:label="item.name"
				:value="item.id">
			</el-option>
		</el-select>
		</div>
    	<div class="main">
      		<template>
        		<el-table border ref="multipleTable" :data="tableData" style="width: 100%" header-cell-class-name="table-header">
          			<el-table-column prop="id" label="ID"></el-table-column>
          			<el-table-column prop="name" label="类型名称" show-overflow-tooltip></el-table-column>
          			<el-table-column prop="sportsKindName" label="运动类型" show-overflow-tooltip></el-table-column>
          			<el-table-column prop="introduction" label="类型介绍" show-overflow-tooltip></el-table-column>
          			<el-table-column prop="forTheCrowd" label="适合人群" show-overflow-tooltip></el-table-column>
					<el-table-column label="操作" width="220" align="center">
						<template slot-scope="scope">
							<!-- <el-button v-has="'course_type_intensity'"
									@click="intensity(scope.row.id)"
									type="text"
									size="small"
									style="color:red;"
									icon="el-icon-s-claim">强度</el-button> -->
							<el-button v-has="'course_type_update'"
									@click="edit(scope.row.id)"
									type="text"
									size="small"
									icon="el-icon-s-order">编辑</el-button>
							<el-popconfirm title="确定删除吗？" @confirm="del(scope.row.id)">
								<el-button v-has="'course_type_delete'"
									slot="reference"
									type="text"
									size="small"
									style="color:red;"
									icon="el-icon-delete">删除</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
        		</el-table>
      		</template>
      		<div class="block" style="padding:30px 10px; float:right">
        		<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
      		</div>
    	</div>
		
    	<!-- 弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      		<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="120px">
      			<input type="hidden" v-model="ruleForm.sportsKindId">
        		<el-form-item label="运动种类" prop="sportsKindId">
          			<el-select v-model="ruleForm.sportsKindName" placeholder="请选择运动类型" style="width: 80%;" @change="rulesportKindId">
            			<el-option v-for="item in selData" :key="item.id" :label="item.name" :value="item.id">{{item.name}}</el-option>
          			</el-select>
        		</el-form-item>
		        <el-form-item label="类型名称" prop="name">
		          	<el-input v-model="ruleForm.name" placeholder="请输入类型名称" style="width: 80%;"></el-input>
		        </el-form-item>
				<el-form-item label="运动类型介绍视频" class="video-upload"> 
	          		<el-input v-model="ruleForm.introVideoUrl" placeholder style="width: 80%;"></el-input>
	          		<el-upload class="avatar-uploader" :headers="headers" :action="tmpFiles1" accept=".mp4, .qlv, .qsv, .ogg, .flv, .avi, .wmv, .rmvb" :show-file-list="false" :before-upload="beforeUploadVideo" :on-success="handleVideoSuccess4" :on-progress="uploadVideoProcess4">
	            		<video v-if="ruleForm.introVideoUrl && videoFlag4 == false" :src="ruleForm.introVideoUrl" width="170" height="170" controls="controls">您的浏览器不支持视频播放</video>
			            <i v-else-if="!ruleForm.introVideoUrl && videoFlag4 == false" class="el-icon-plus avatar-uploader-icon"></i>
			            <el-progress v-if="videoFlag4 == true" type="circle" :percentage="videoUploadPercent4" style="margin-top:30px"></el-progress>
	          		</el-upload>
	        	</el-form-item>
		        <el-form-item label="类型介绍" prop="introduction" >
		          	<el-input type="textarea" v-model="ruleForm.introduction" style="width:80%" :rows="4"></el-input>
		        </el-form-item>
		        <el-form-item label="适合人群" prop="forTheCrowd">
		          	<el-input type="textarea" v-model="ruleForm.forTheCrowd" style="width:80%" :rows="4"></el-input>
		        </el-form-item>
		        <el-form-item label prop="id" v-show="isShow">
		          	<el-input v-model="ruleForm.id" placeholder></el-input>
		        </el-form-item>
				
		    </el-form>
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit()">确 定</el-button>
		    </span>
    	</el-dialog>
		<!-- 强度弹窗 -->
    	<el-dialog title="强度管理" :visible.sync="dialogVisible3" width="60%" :before-close="handleClose3" class='stagecon'>
	      	
	      	<el-table :data="intensityData" style="width: 100%" ref="multipleTable">
		        <el-table-column label="强度名称" prop="name">
			        <template slot-scope="scope">
			            <el-input v-model="scope.row.name"></el-input>
			        </template>
		        </el-table-column>
		        <el-table-column prop="star" label="星级">
		          	<template slot-scope="scope">
		            	<el-input v-model="scope.row.star"></el-input>
		        	</template>
		        </el-table-column>
		        <el-table-column prop="endurance" label="耐力">
		          	<template slot-scope="scope">
		            	<el-input v-model="scope.row.endurance"></el-input>
		          	</template>
		        </el-table-column>
		        <el-table-column prop="strength" label="力量" >
		          	<template slot-scope="scope">
		            	<el-input v-model="scope.row.strength"></el-input>
		          	</template>
		        </el-table-column>
		        <el-table-column prop="skill" label="技巧">
		          	<template slot-scope="scope">
		            	<el-input v-model="scope.row.skill"></el-input>
		          	</template>
		        </el-table-column>
		        <el-table-column prop="fatBurning" label="燃脂">
		          	<template slot-scope="scope">
		            	<el-input v-model="scope.row.fatBurning"></el-input>
		          	</template>
		        </el-table-column>
		        <el-table-column prop="cardiopulmonary" label="心肺">
			        <template slot-scope="scope">
			        	<el-input v-model="scope.row.cardiopulmonary"></el-input>
			        </template>
		        </el-table-column>
		        <el-table-column prop="physicalMental" label="身心">
		          	<template slot-scope="scope">
		            	<el-input v-model="scope.row.physicalMental"></el-input>
		          	</template>
		        </el-table-column>
	      	</el-table>
			
			<div class="addBtn">
				<el-button type="primary" @click="addLine" plain>添加行</el-button>
	      		<el-button type="danger" @click="delLine" plain>删除行</el-button>
			</div>

	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible3 = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit3()">确 定</el-button>
	      	</span>
	    </el-dialog>
  	</div>
</template>  
<script>
export default {
  	components: {},
  	mounted() {
    	this.init();
		this.initOtherMethod();
  	},
  	data() {
	    return {
	      	headers: {
                'yj-admin-token': localStorage.getItem("token")
            },
			tmpFiles1: process.env.API_ROOT + '/courses/kinds/intro/video',
	      	selData: [], //选择运动种类
	      	tableData: [],
	      	pageNum: 1,
	      	limit: 10,
	      	totalPage: 10,
	      	currentRow: "",
	      	ruleForm: {
		        forTheCrowd: "",
		        id: "",
		        introduction: "",
		        name: "",
		        sportsKindId: "",
				introVideoUrl:''
	      	},
	      	ruleForms: {
	        	sportsKindId: [{ required: true, message: "请选择运动类型" }],
	        	name: [{ required: true, message: "请输入类型名称" }]
	      	},
	      	dialogVisible: false,
	      	isShow: false,
	      	dialogVisible3: false,
			selectSportsId:'', 
			videoFlag4: false,
            videoUploadPercent4: '0%', 
			sportsKindList:[],
	      	intensityData:[]//强度管理数据
	    };
  	},
  	methods: {
    	//初始化表格数据
    	init() {
	      	var params = {
	        	pageNum: this.pageNum,
	        	limit: this.limit,
				sportsKindId:this.selectSportsId!='0'?this.selectSportsId:''
	      	};
      		this.$get("/courses/kinds", params)
        	.then(res => {
	          	if (res.code == 0) {
	            	this.tableData = res.data.list;
	            	this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
        	})
	        .catch(() => {
	          	console.log();
	        });
    	},
		initOtherMethod(){
			this.$get("/course/sportsKind")
        	.then(res => {
	          	if (res.code == 0) {
	            	this.sportsKindList = Array.isArray(res.data)?res.data:[];
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
        	})
	        .catch(() => {
	          	console.log();
	        });
		},
		selectChage(){
			this.pageNum=1;
			this.init();
		},
    	//当前页数
    	handleCurrentChangePage(val) {
      		this.pageNum = val;
      		this.init();
    	},
		// 视频2
        beforeUploadVideo(file) {
            //视频上传之前判断他的大小
            const isLt10M = file.size / 1024 / 1024 < 2000;
            if (!isLt10M) {
                this.$message.error('上传视频大小不能超过2000MB哦!');
                return false;
            }
        },
        handleVideoSuccess4(res, file) {
            //视频上传成功之后返回视频地址
            this.videoFlag4 = false;
            this.videoUploadPercent4 = 0;
            this.ruleForm.introVideoUrl = res.data;
        },
		uploadVideoProcess4(event, file, fileList) {
            //视频上传的时候获取上传进度传给进度条
            this.videoFlag4 = true;
            this.videoUploadPercent4 = parseInt(file.percentage);
        },
    	//弹框关闭按钮
    	handleClose(done) {
      		if (this.$refs.ruleForm != undefined) {
        		this.$refs.ruleForm.resetFields();
      		}
      		done();
    	},
    	rulesportKindId(val){//修改运动类型
	      	this.ruleForm.sportsKindId=val;
	    },
    	//选择需要修改的权限
    	handleCurrentChange(val) {
      		if (val) {
        		this.currentRow = val.id;
      		}
    	},
	    intensity(currentRowId){//强度
	    	this.$get("/courses/kinds/intensity/" + currentRowId)
      			.then(res => {
					console.log('res',res);
        			if (res.code == 0) {
          				this.dialogVisible3 = true;
          				this.$nextTick(function() {
            				this.intensityData = res.data;
          				});
        			}else{
						this.$message.error(JSON.stringify(res.message));
					}
      			})
      			.catch(() => {});
	    },
	    handleClose3() {
	      	this.dialogVisible3 = false
	    },
	    addLine() {
	      	//添加行数
	      	var newValue = {
		        name: "",
		        star: "",
		        endurance: "",
		        strength: "",
		        skill: "",
		        fatBurning: "",
		        cardiopulmonary: "",
		        physicalMental: ""
	      	};
	      	//添加新的行数
	      	this.intensityData.push(newValue);
	    },
	    delLine() {//删除行数
	      	this.intensityData.pop(); 	
	    },
	    onSubmit3() {
	    	var istrue=false;
			this.intensityData.map((item)=>{
	          	for (var k in item){
	              	if(item[k]===''){
						this.$message.error('input不能为空');
						istrue=false;
						return false
					}else{
						istrue=true
					}
	          	}
	      	})
	      	console.log(this.intensityData)
	      	if(istrue==true){
	      		this.$axios.put("/courses/kinds/intensity/" + this.currentRow,JSON.stringify(this.intensityData))
		        .then(res => {
		        	console.log(res)
		          	if (res.data.code == 0) {
			            this.$message({
			              	message: "保存成功",
			              	type: "success"
			            });
			            this.dialogVisible3 = false;
                  		this.currentRow='';
			            this.pageNum=1;
			            this.init();
		          	} else {
			            this.$message({
			              	message: res.data.message,
			              	type: "warning"
			            });
			            return false;
		          	}
		        })
		        .catch(() => {
		          	console.log();
		        });
	      	}
	      	
	    },
    	//选择门店
    	sportsKind() {
	      	this.$get("/course/sportsKind", {})
	        .then(res => {
	          	if (res.code == 0) {
	            	this.selData = res.data;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	        .catch(() => {
	          	console.log();
	        });
    	},
    	//添加
    	add(row) {
    		const ruleForm={
		        forTheCrowd: "",
		        id: "",
		        introduction: "",
		        name: "",
		        sportsKindId: "",
				introVideoUrl:''
	      	};
			this.ruleForm=ruleForm;
	      	this.currentRow='';
	      	this.dialogVisible = true;
	      	this.sportsKind();
    	},
    	onSubmit() {
      		var that = this;
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					const method=that.ruleForm.id?that.$put:that.$post;
					const url=that.ruleForm.id?"/courses/kinds/" + this.ruleForm.id:'/courses/kinds'
					this.loading = true;
					method(url,JSON.stringify(this.ruleForm))
					.then(res => {
						if (res.code == 0) {
							this.$message.success('操作成功');
							this.dialogVisible = false;
							this.init();
						} else {
							this.$message.error(JSON.stringify(res.message));
						}
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
					});
				} else {
					this.$message.error('有必填项未填写');
				}
			});
    	},
    	edit(currentRowId) {
      		this.sportsKind();
      		this.$get("/courses/kinds/" + currentRowId)
          		.then(res => {
            		if (res.code == 0) {
		              	this.$nextTick(function() {
		                	this.ruleForm = res.data;
		              	});
						this.dialogVisible = true;
            		}else{
						this.$message.error(JSON.stringify(res.message));
					}
          		})
          		.catch(() => {});
    	},
    	del(currentRowId) {
      		this.$delete("/courses/kinds/" + currentRowId)
			.then((res)=>{
				console.log(res);
				if (res.code == 0) {
					this.$message.success('删除成功');
					this.pageNum = 1;
					this.init();
					this.dialogVisible = false;
				} else {
					this.$message.error(JSON.stringify(res.message));
				}
			})
			.catch(function(err) {
				console.log(err);
			});
    	},
    	//选择图片成功
    	handleAvatarSuccess(res, file) {
	      	console.log(res);
	      	this.ruleForm.photo = res.data.url;
    	},
    	beforeAvatarUpload(file) {
	      	console.log("000");
	      	const isJPG = file.type === "image/jpeg";
	      	const isLt2M = file.size / 1024 / 1024 < 2;

	      	if (!isJPG) {
	        	this.$message.error("上传头像图片只能是 JPG 格式!");
	      	}
	      	if (!isLt2M) {
	        	this.$message.error("上传头像图片大小不能超过 2MB!");
	      	}
	      	return;
    	},
  	}
};
</script>

<style scoped>
/*.el-input {
  	width: 80%;
}
.el-textarea__inner {
  	width: 80%;
}*/
.avatar-uploader {
  	padding-top: 20px;
}
.el-upload {
  	border: 1px dashed #d9d9d9;
  	border-radius: 6px;
  	cursor: pointer;
  	position: relative;
  	overflow: hidden;
}
.el-upload:hover {
  	border-color: #409eff;
}
.avatar-uploader-icon {
  	font-size: 28px;
  	color: #8c939d;
  	width: 178px;
  	height: 178px;
  	line-height: 178px;
  	text-align: center;
}
.avatar {
  	width: 178px;
  	height: 178px;
  	display: block;
}
.selectUser {
  	color: #409eff;
}
.selectUser label,
.selectUser i {
  	font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/courses/index.vue